import styled from '@emotion/styled'
import { Pagination } from '@mui/material'

import type { IPaginationProps } from './types'

const PaginationStyled = styled(Pagination)<IPaginationProps>(() => ({
  width: 'auto',

  '.MuiPagination-ul': {
    width: '100%',
    backgroundColor: 'transparent',
  },

  '.Mui-selected': {
    borderRadius: '8px',
    color: '#fff !important',
    backgroundColor: '#19171b !important',
  },

  '.MuiPaginationItem-root': {
    width: '40px',
    height: '40px',
    color: '#19171b',
    borderRadius: '0px',
    backgroundColor: 'transparent ',
    border: '1px solid #19171b',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.MuiPaginationItem-root:hover': {
    backgroundColor: '#19171b',
    color: '#fff',
  },
}))

export default PaginationStyled
